import { FC } from 'react';
import styles from './GeneralTab.module.scss';
import { TEMPLATE_OPTION_IDS } from "../../helper";
import appState from '../../../../state/AppStateContainer';
import SignupFunnelSection from './SignupFunnelSection';

type Props = {
  templateItemRenderer: (id: TEMPLATE_OPTION_IDS) => JSX.Element,
}

const GeneralTab: FC<Props> = ({ templateItemRenderer }) => {
  return (
    <div className={styles.tabContainer}>
      {appState.superAdminOrgAndUser() && <SignupFunnelSection />}
      <div className={styles.container}>
        {appState.superAdminOrgAndUser() && templateItemRenderer('36')}
        {templateItemRenderer('4')}
        {/* {templateItemRenderer('15')} */}
        {templateItemRenderer('16')}
        {templateItemRenderer('17')}
        {templateItemRenderer('18')}
        {templateItemRenderer('19')}
        {templateItemRenderer('21')}
        {templateItemRenderer('35')}
      </div>
      <div className={styles.chartContainer}>
        {templateItemRenderer('22')}
        {templateItemRenderer('34')}
      </div>
    </div>
  )
}

export default GeneralTab;
